/* rb-b-shade.js — whole-collection shade sort, as a toggle above the grid.

   THE CONTROL (rev 2, 2026-09-29, Mark: "can we make it a separate toggle?")
   Not in the sort dropdown any more. A row above the grid:
       SHADE  [Light → dark] [Dark → light]
   styled like the fit rail's shade chips, so the two read as one feature.
   Tap a chip to sort, tap the lit chip again to go back to the normal order.
   Picking any sort in the dropdown also turns shade off. Same row on desktop
   and phone (on the phone it sits under the Filter and sort / Size / Brand row).

   WHERE THE NUMBERS COME FROM
   custom.denim_shade (0-100, one scale across every brand, blacks < 1) —
   backfilled 2026-09-29, new drops scored in the Bulk Editor's swatch review.
   See rooster-notes/denim-shade-sort/README.md. custom.wash_lightness (the
   per-fit scale behind the fit rail's shade chips) is a different number and
   is not read here.

   WHY IT FETCHES EVERY PAGE
   Shopify cannot sort a collection by a metafield, and a client-side reorder of
   one page only sorts that page — it would look finished and be wrong. So this
   pulls every page of the CURRENT result set (filters kept) through the Section
   Rendering API, merges the cards, sorts the lot and hides pagination. Denim is
   ~190 products = 4 pages. Capped at MAX_PAGES. The shade map comes from
   templates/collection.rbb-shade.liquid (?view=rbb-shade).

   STATE survives a filter change: DynamicProductSearch rebuilds the section
   and drops unknown URL params, so the direction lives in sessionStorage
   (per pathname) as well as in ?shade=. When fresh server cards appear, the
   sort re-runs against the new result set. Turning it off puts back the cards
   that were on the page before sorting, in their order — no reload.

   Sold-out cards stay at the end in both directions (nightly reorder doctrine).
   Cards with no shade go after the scored ones, before sold-out. */

(function () {
  'use strict';

  var cfg = document.getElementById('rbb-shade-cfg');
  if (!cfg) return;

  var MAX_PAGES = 8;
  var KEY = 'rbbShade:' + location.pathname;

  function getDir() {
    var p = new URLSearchParams(location.search).get('shade');
    if (p === 'light' || p === 'dark') return p;
    try { var s = sessionStorage.getItem(KEY); if (s === 'light' || s === 'dark') return s; } catch (e) {}
    return null;
  }
  function setDir(d) {
    try { if (d) sessionStorage.setItem(KEY, d); else sessionStorage.removeItem(KEY); } catch (e) {}
    var u = new URL(location.href);
    if (d) u.searchParams.set('shade', d); else u.searchParams.delete('shade');
    history.replaceState(history.state, '', u.pathname + u.search + u.hash);
  }

  /* ---------- the toggle ---------- */
  var LABELS = { light: 'Light → dark', dark: 'Dark → light' };

  function ensureBar() {
    var grid = document.querySelector('.collection__cards');
    if (!grid) return null;
    var bar = document.querySelector('.rbb-shade-bar');
    if (bar && bar.nextElementSibling === grid) return bar;
    if (bar) bar.remove();
    bar = document.createElement('div');
    bar.className = 'rbb-shade-bar';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Sort by wash shade');
    var lab = document.createElement('span');
    lab.className = 'rbb-shade-bar__label';
    lab.textContent = 'Shade';
    bar.appendChild(lab);
    ['light', 'dark'].forEach(function (d) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rbb-shade-chip';
      b.setAttribute('data-dir', d);
      b.setAttribute('aria-pressed', 'false');
      b.textContent = LABELS[d];
      b.addEventListener('click', function () {
        if (getDir() === d) off(); else on(d);
      });
      bar.appendChild(b);
    });
    var st = document.createElement('span');
    st.className = 'rbb-shade-bar__status';
    st.setAttribute('aria-live', 'polite');
    bar.appendChild(st);
    grid.parentNode.insertBefore(bar, grid);
    paintBar();
    return bar;
  }

  function paintBar(status) {
    var bar = document.querySelector('.rbb-shade-bar');
    if (!bar) return;
    var d = getDir();
    bar.querySelectorAll('.rbb-shade-chip').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-dir') === d));
    });
    var st = bar.querySelector('.rbb-shade-bar__status');
    if (st) st.textContent = status || '';
  }

  function on(d) {
    setDir(d);
    paintBar();
    run(d);
  }

  function off() {
    runId++;              // abandon anything in flight
    running = false;
    setDir(null);
    var grid = document.querySelector('.collection__cards');
    if (grid && origCells && origGrid === grid) {
      var frag = document.createDocumentFragment();
      origCells.forEach(function (c) { c.removeAttribute('data-rbb-shaded'); frag.appendChild(c); });
      grid.innerHTML = '';
      grid.appendChild(frag);
      grid.classList.remove('rbb-shade-loading');
      document.documentElement.classList.remove('rbb-shade-on');
      paintBar();
    } else {
      location.reload();
    }
  }

  // Any sort from the dropdown means "not shade".
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('js-collection-sort') && getDir()) {
      runId++;
      running = false;
      setDir(null);
      paintBar();
    }
  }, true);

  /* ---------- fetch + sort ---------- */
  function sectionId() {
    var s = document.querySelector('.js-section__collection');
    var w = s && s.closest('[id^="shopify-section-"]');
    return w ? w.id.replace('shopify-section-', '') : null;
  }
  function baseParams() {
    var u = new URL(location.href);
    u.searchParams.delete('shade');
    u.searchParams.delete('page');
    u.searchParams.delete('section_id');
    u.searchParams.delete('view');
    return u;
  }
  function maxPage(root) {
    var m = 1;
    root.querySelectorAll('.collection-pagination a[href*="page="], .pagination a[href*="page="]').forEach(function (a) {
      var n = parseInt(new URL(a.href, location.origin).searchParams.get('page'), 10);
      if (n > m) m = n;
    });
    return m;
  }
  function currentPage() {
    return parseInt(new URLSearchParams(location.search).get('page'), 10) || 1;
  }
  function cellsOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.collection__cards > .o-layout__item'))
      .filter(function (c) { return c.querySelector('[data-product-id]'); });
  }
  function pid(cell) {
    var el = cell.querySelector('[data-product-id]');
    return el ? el.getAttribute('data-product-id') : null;
  }

  var runId = 0;
  var running = false;
  var origCells = null;   // the server's cards + order, for turning shade off
  var origGrid = null;

  function run(dir) {
    var my = ++runId;
    running = true;
    var grid = document.querySelector('.collection__cards');
    if (!grid) return;
    // Remember the unsorted page (only while it IS unsorted — a re-run over
    // already-sorted cards must not overwrite the real original).
    var fresh = cellsOf(document);
    if (fresh.length && !fresh[0].hasAttribute('data-rbb-shaded')) {
      origCells = fresh;
      origGrid = grid;
    }
    grid.classList.add('rbb-shade-loading');
    ensureBar();
    paintBar('Sorting…');

    var sid = sectionId();
    var pages = Math.min(maxPage(document), MAX_PAGES);
    var here = currentPage();
    var mapUrl = baseParams(); mapUrl.searchParams.set('view', 'rbb-shade');

    var jobs = [fetch(mapUrl.pathname + mapUrl.search, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('map ' + r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t); })];
    for (var p = 1; p <= pages; p++) {
      if (p === here) { jobs.push(Promise.resolve(null)); continue; }
      var u = baseParams();
      u.searchParams.set('page', p);
      if (sid) u.searchParams.set('section_id', sid);
      jobs.push(fetch(u.pathname + u.search, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('page ' + r.status); return r.text(); })
        .then(function (h) { return new DOMParser().parseFromString(h, 'text/html'); }));
    }

    Promise.all(jobs).then(function (res) {
      if (my !== runId) return;
      running = false;
      var shade = (res[0] && res[0].shade) || {};
      var cur = document.querySelector('.collection__cards');
      if (!cur) return;
      var seen = {}, all = [];
      var order = 0;
      for (var i = 1; i < res.length; i++) {
        var list = res[i] ? cellsOf(res[i]) : cellsOf(document);
        list.forEach(function (c) {
          var id = pid(c);
          if (!id || seen[id]) return;
          seen[id] = 1;
          var v = shade[id];
          all.push({
            cell: res[i] ? document.importNode(c, true) : c,
            s: typeof v === 'number' ? v : null,
            out: !!c.querySelector('.product-card--sold-out'),
            o: order++
          });
        });
      }
      all.sort(function (a, b) {
        if (a.out !== b.out) return a.out ? 1 : -1;
        if (a.s === null && b.s === null) return a.o - b.o;
        if (a.s === null) return 1;
        if (b.s === null) return -1;
        if (a.s === b.s) return a.o - b.o;
        return dir === 'light' ? b.s - a.s : a.s - b.s;
      });
      var frag = document.createDocumentFragment();
      all.forEach(function (x) { x.cell.setAttribute('data-rbb-shaded', '1'); frag.appendChild(x.cell); });
      cur.innerHTML = '';
      cur.appendChild(frag);
      cur.classList.remove('rbb-shade-loading');
      document.documentElement.classList.add('rbb-shade-on');
      var capped = maxPage(document) > MAX_PAGES;
      paintBar(capped ? 'first ' + MAX_PAGES + ' pages only' : '');
    }).catch(function () {
      if (my !== runId) return;
      running = false;
      var g = document.querySelector('.collection__cards');
      if (g) g.classList.remove('rbb-shade-loading');
      paintBar('Couldn’t load every page. Try again.');
    });
  }

  /* ---------- boot + re-render ---------- */
  function boot() {
    ensureBar();
    var d = getDir();
    if (d) { setDir(d); run(d); }   // persist a ?shade= arrival so filter clicks keep it

    var section = document.querySelector('.js-section__collection');
    if (!section || !window.MutationObserver) return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        ensureBar();   // a re-render can take the row with it
        // A re-render (filter change) brings fresh, unsorted cards — whether
        // DynamicProductSearch swapped the grid node or only its children. Our
        // own sorted cells carry data-rbb-shaded, server-rendered ones don't.
        var g = document.querySelector('.collection__cards');
        var first = g && g.querySelector(':scope > .o-layout__item');
        if (first && !first.hasAttribute('data-rbb-shaded')) {
          document.documentElement.classList.remove('rbb-shade-on');
          var dd = getDir();
          if (dd && !running) { setDir(dd); run(dd); }
        }
      }, 150);
    }).observe(section, { childList: true, subtree: true });
  }

  window.rbbShade = { run: run, dir: getDir };   // for debugging in the console

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
